import { render, staticRenderFns } from "./ChallengeViewHeader.vue?vue&type=template&id=ca57453c&scoped=true"
import script from "./ChallengeViewHeader.vue?vue&type=script&lang=js"
export * from "./ChallengeViewHeader.vue?vue&type=script&lang=js"
import style0 from "./ChallengeViewHeader.vue?vue&type=style&index=0&id=ca57453c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca57453c",
  null
  
)

export default component.exports